<template>
  <div class="convertible-block-cont">
    <!-- Designer image -->
    <product-img
      :customised-product="customisedProduct"
      :view-angle="2"
      :ck-demo-mode="true"
      :invert="invert"
      @click="invertDesign"
    />

    <div class="convert-right">
      <BaseHeading :class="$b('title')">
        {{ $tr('Convert your Kit.') }}
      </BaseHeading>
      <p
        v-if="frameType === 'tf'"
        class="desc"
      >
        {{
          $tr(
            'Built to Adapt. Add a Base Frame to unlock both TF and FF frame styles.'
          )
        }}
      </p>
      <p
        v-else-if="frameType === 'ff'"
        class="desc"
      >
        {{
          $tr(
            'Built to Adapt. Add a Nose Piece to unlock both TF and FF frame styles.'
          )
        }}
      </p>
      <p
        v-else-if="frameType === 'bf'"
        class="desc"
      >
        {{
          $tr(
            'Built to Adapt. Add a Nose Piece to unlock both BF and ZF frame styles.'
          )
        }}
      </p>
      <p
        v-else-if="frameType === 'zf'"
        class="desc"
      >
        {{
          $tr(
            'Built to Adapt. Add a Base Frame to unlock both BF and ZF frame styles.'
          )
        }}
      </p>

      <base-toggle
        v-model="checked"
        class="ConvertYourKit__toggle"
        :on-label="'ON'"
        :off-label="'OFF'"
        @click="handleClick"
      />
    </div>
  </div>
</template>

<script>
import CustomisedProduct from '~/models/CustomisedProduct'

export default {
  name: 'ConvertYourKit',
  props: {
    customisedProduct: { type: CustomisedProduct, required: true },
    frameType: { type: String, required: true },
    conversionKitEnabled: { type: Boolean, required: true },
  },
  data() {
    return {
      invert: false,
      checked: this.customisedProduct.conversionKitEnabled,
    }
  },
  watch: {
    checked() {
      this.checked = this.customisedProduct.conversionKitEnabled
    },
    conversionKitEnabled(state) {
      this.invert = state
      if (this.checked !== state) this.checked = state
    },
  },
  methods: {
    handleClick() {
      this.customisedProduct.toggleConversionKit()
    },
    handleChange() {
      if (!this.checked) return
      setTimeout(() => {
        this.$scrollTo('#top')
      }, 600)
    },
    invertDesign() {
      const isInverted = this.invert
      this.invert = !isInverted
      setTimeout(() => {
        this.invert = isInverted
      }, 1000)
    },
  },
}
</script>

<style lang="postcss">
.ConvertYourKit__title {
  @apply mb-sm;
}

.convertible-block-cont {
  @apply bg-grey-light;
  text-align: center;
  padding: 15px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .img-cont#img-cont-2 {
    max-width: 800px;
    padding-bottom: 80px;
    margin-top: 40px;

    @screen sm {
      width: 50%;
    }

    img {
      position: absolute;
      top: -40px !important;
      transition: 0.3s ease-in-out top;
      transform: none;

      &.spacer {
        position: relative;
        opacity: 0;
      }

      &.convert {
        top: 100px !important;
      }

      &.lens-ff {
        opacity: 0;
      }
    }
  }

  .ConvertYourKit__toggle {
    margin-top: 1rem;
  }

  &.activate {
    .img-cont#img-cont-2 img {
      &.convert {
        top: -40px !important;
      }

      &.convert-from {
        top: 100px !important;
      }

      &.lens-tf {
        opacity: 0;
      }

      &.lens-ff {
        opacity: 1;
      }
    }
  }

  .desc-ff {
    display: none;
  }

  p.desc {
    font-weight: 200;
  }

  .toggles {
    position: unset;
    left: unset;
    top: unset;
    -webkit-tap-highlight-color: transparent;

    margin: 60px 0 40px 0;

    .container {
      position: unset;
      top: unset;
      display: inline-block;
      -webkit-tap-highlight-color: transparent;

      p {
        margin: 0;
        width: 50px;
        padding: 0;
        font-size: 10px;
        font-weight: 600;
        display: inline-block;
        vertical-align: top;
        line-height: 24px;
      }
    }
  }
}

@screen mdMax {
  .convertible-block-cont {
    flex-direction: column;
    padding-bottom: 4em;
  }
}
</style>
